import React from 'react';
import './CourseDetaileTimeLine.scss'
import { Icon } from '@vds/icons'
import { Body, Title } from '@vds/typography';

const Timeline = ({ items }) => {
  return (
    <div className="timeline_wrapper">
      <div className="timeline_line"></div>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <div key={index} className={`timeline_item ${isLast ? ' timeline_item_last' : ''}`}>
            <div className="timeline_icon_container">
              <Icon name={item.icon} color="rgba(115, 39, 6, 1)" />
            </div>
            <div className="timeline_content">
              {item.title && <Title size='small'>{item.title}</Title>}
              {item.status && (
                <div className='mt-1X'>
                  <Body size='small'>{item.status}</Body>
                  {item.duration && <Body size='small'>{item.duration}</Body>}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;